<div>
  @if (journey) {
    <app-trigger-selector
      [journey]="journey"
      (triggerSelected)="selectTrigger($event)"
      (selectionCanceled)="cancelSelectedTrigger()">
    </app-trigger-selector>
  }

  @if (journey) {
    <div class="launcher-content">
      @if (fetchingUsers) {
        <div>
          <app-spinner class="mask"></app-spinner>
        </div>
      }
      <rn-progress-tabs [tabs]="statusTabs" [selectedTabId]="journeyLaunchState"></rn-progress-tabs>
      @if (journeyLaunchState != journeyLaunchStates['successfullyLaunched']) {
        <div class="launcher-inner-content">
          @if (!triggerComponent) {
            <div class="mask"><div ><h2 style="color:white;text-align:center">Please select a trigger</h2></div></div>
          }
          <tabset #launcherTabs class="launcher-tabs">
            <tab heading="Select from existing  users" (select)="onSelectUsersTab($event)">
              @if (currentStep === -1) {
                <div class="select-user-tab-content">
                  @if (tab1ValidationError) {
                    <label class="validation-error">{{tab1ValidationError}}</label>
                  }
                  <p>Search by Name, Mobile Number, or Account ID (CCID).</p>
                  <div class="multi-select-wrapper" (click)="focusSearchText()">
                    <div class="multi-select">
                      <ul class="selected-users">
                        @for (user of selectedUsers; track user) {
                          <li class="user"><span style="text-transform:capitalize">{{user.name.toLowerCase()}}</span><span class="deselect" (click)="deselectUser(user)"><i class="fa fa-times"></i></span></li>
                        }
                      </ul>
                      <input id="customer-search-input" #searchTextInput [(ngModel)]="searchText" (keyup.enter)="submitSearchRequest()"/>
                    </div>
                    <button id="submit-search" class="submit-search btn btn-primary" (click)="submitSearchRequest()">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  <div class="selectable-list">
                    <div class="list-row list-row--header">
                      <div class="list-column">Name</div>
                      <div class="list-column">Mobile Number</div>
                      <div class="list-column">Account ID (CCID)</div>
                      <div class="list-column">Product Group</div>
                      <div class="list-column column-icon"></div>
                    </div>
                    @for (user of searchList; track user) {
                      <div class="list-row" [ngClass]="{'list-row-disabled' : customerAllStopConsent(user)}" (click)="onUserRowClick(user)">
                        <div class="list-column">
                          <span>&nbsp;<input [disabled]="customerAllStopConsent(user)" type="checkbox" [(ngModel)]="user.selected" (change)="addToSelectedUsers(user)" (click)="$event.stopPropagation()"/>&nbsp;</span>
                          {{user.name.toLowerCase()}}
                        </div>
                        <div class="list-column">
                          @for (phone of user.notification_channels; track phone) {
                            @if (phone.channel_type === 'sms') {
                              <div class="phone-number">{{phone.phone_number | phoneNumber}}</div>
                            }
                          }
                        </div>
                        <div class="list-column">{{user.ccid}}</div>
                        <div class="list-column">{{user.product_group_id}}</div>
                        <div class="list-column column-icon">@if (customerAllStopConsent(user)) {
                          <i class="fa fa-exclamation-circle" [matTooltip]="getConsentTooltip(user)" matTooltipPosition="above"></i>
                        }</div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (currentStep >= 0) {
                <div>
                  <div style="text-align:center;">
                    <div>{{currentStep + 1}} of {{selectedUsers.length}}</div>
                    <div>
                      @for (child of selectedUsers; track child; let i = $index) {
                        <span class="dot" [class.active]="i === currentStep" (click)="setFormsByIndex(i)">
                        </span>
                      }
                    </div>
                  </div>
                  <app-input-params [(inputParams)]="inputParams" [selectedUser]="selectedUsers[currentStep]" (statusChanged)="checkInputReadyState()"></app-input-params>
                  <label for="client_message_tag">Client Message Tag (optional)</label>
                  <input type="text" class="form-control client_message_tag" id="client_message_tag" [(ngModel)]="clientMessageTags[currentStep]">
                  <div style="text-align:center;">
                    <div>
                      @for (child of selectedUsers; track child; let i = $index) {
                        <span class="dot" [class.active]="i === currentStep" (click)="setFormsByIndex(i)">
                        </span>
                      }
                    </div>
                    <div>{{currentStep + 1}} of {{selectedUsers.length}}</div>
                  </div>
                </div>
              }
              <br/>
              <div class="pull-left">
                @if (currentStep !== - 1) {
                  <div (click)="getPrevForm()" class="btn btn-primary">
                    <span class="icon icon-left"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                    <span i18n="Next button label for launch">previous</span>
                  </div>
                }
              </div>
              <div class="pull-right">
                @if (currentStep !== (selectedUsers.length - 1)) {
                  <div (click)="getNextForm()" class="btn btn-primary">
                    <span i18n="Next button label for launch">Next</span>
                    <span class="icon icon-right"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                  </div>
                }
                @if (currentStep === (currentStep >= 0 && (selectedUsers.length - 1))) {
                  <div class="btn btn-lg btn-default" (click)="scheduleLaunch()" id="schedule-button"
                    [class.inactive]="journeyLaunchState !== journeyLaunchStates.readyToLaunch"
                    >
                    <span i18n="Schedule button label">Schedule</span>
                    <span class="icon icon-right"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                  </div>

                  <div class="btn btn-lg btn-warning" (click)="onLaunchButtonClicked()" id="launch-button"
                    [class.inactive]="journeyLaunchState !== journeyLaunchStates.readyToLaunch"
                    >
                    <span i18n="Launch button label">Launch</span>
                    <span class="icon icon-right"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                  </div>
                }
              </div>
              <div class="clearfix"></div>
            </tab>
            <!-- the condition on the container will only show/hide the tab -->
            @if (hasRequiredPermission()) {
              <tab heading="Upload a file" (select)="onSelectUploadTab()">
                <!-- this condition will hide the actual upload UI. -->
                @if (triggerComponent) {
                  <rn-file-launcher [triggerId]="triggerComponent.name"></rn-file-launcher>
                }
              </tab>
            }
          </tabset>
          <br/>
          <div class="bottom-buttons">
            <div class="pull-left">
              <div class="cancel-link" (click)="goBack()">
                <span class="icon"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                <span i18n="Label for cancel button">Cancel</span>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      }
      @if (journeyLaunchState == journeyLaunchStates['successfullyLaunched'] && currentTab === tabs.upload) {
        <div class="launcher-inner-content">
          <journey-launched
            [launchResult]="journeyLaunchResponse"
            [leftButtonLabel]="'Monitor'"
            (leftButtonClick)="monitor()"
            [rightButtonLabel]="'Launch Again'"
            (rightButtonClick)="launchAgain()"
            [scheduleTime]="scheduleTime">
          </journey-launched>
        </div>
      }
      @if (journeyLaunchState == journeyLaunchStates['successfullyLaunched'] && currentTab === tabs.selectUser) {
        <div class="launcher-inner-content">
          <journey-launched
            [launchResult]="journeyLaunchResponse"
            [rightButtonLabel]="'Launch Again'"
            (rightButtonClick)="launchAgain()"
            [scheduleTime]="scheduleTime">
          </journey-launched>
        </div>
      }
    </div>
    }
</div>

<schedule-launch-dialog
  [title]="'Schedule Launch'"
  [(showDialog)]="showSchedulingDialog"
  [(scheduleTime)]="scheduleTime"
  (confirmTime)="onConfirmScheduledLaunchTime()"
>
  <ng-container schedule-button-content>
    <span
      class="btn-label"
      i18n="Label for button that immediately launches an experience"
      >Schedule Launch</span
    >
    <span class="icon icon-right"
      ><i class="fa fa-paper-plane" aria-hidden="true"></i
    ></span>
  </ng-container>
</schedule-launch-dialog>

<message-dialog #errorDialog></message-dialog>

<message-dialog
  #scheduleWarningDialog
  id="scheduleWarningDialog"
  [showClose]="true"
  [showCancel]="true"
  [cancelButtonClass]="'btn-link'"
  [affirmButtonText]="'Schedule'"
  [affirmButtonClass]="'btn-primary'"
  (affirm)="onConfirmScheduledWarning()">
  <h4>Schedule Experience</h4>
  <p>
    You are about to schedule this experience. This will launch this experience to your selection of contacts on the date and time you’ve selected.
    Please verify this information, as well as whether you’re scheduling for an AM or PM send.
  </p>
</message-dialog>

<message-dialog
  #launchWarningDialog
  id="launchWarningDialog"
  [showClose]="true"
  [showCancel]="true"
  [cancelButtonClass]="'btn-link'"
  [affirmButtonText]="'Launch'"
  [affirmButtonClass]="'btn-primary'"
  (affirm)="onConfirmLaunchWarning()">
  <h4>Launch Experience</h4>
  <p>
    You are about to launch this experience. This will immediately send this experience to your selection of contacts.
    Please make sure both the experience selected and contacts are correct.
  </p>
</message-dialog>

<message-dialog
  #blackoutWarningDialog
  id="blackoutWarningDialog"
  [showCancel]="true"
  (affirm)="onAffirmScheduleInBlackoutWindow()"
  (cancel)="onCancelScheduleInBlackoutWindow(!isOnSelectUserTab())"
>
  <p style="text-align: left">
    You've chosen a time that is in the blackout window ({{
      blackoutStartDisplay
    }}
    to {{ blackoutEndDisplay }} Eastern Time. {{ weekendBlackoutMessage }}). If
    you use this time, customers cannot receive the SMS for this launch until
    {{ blackoutEndDisplay }} Eastern Time after the scheduled time.
  </p>

  <p>
    {{
      isOnSelectUserTab()
        ? 'Would you like to proceed?'
        : 'Would you like to proceed with this time? Click cancel to choose another time.'
    }}
  </p>
</message-dialog>
